import { motion } from "framer-motion";
import { TrendingUp } from "lucide-react";

export default function WhatsNextInfo() {
  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ delay: 0.8 }}
      className="p-4 mt-8 bg-gradient-to-r from-blue-50 to-cyan-50 rounded-xl border border-blue-200 shadow-sm"
    >
      <div className="flex gap-3 items-start">
        <div className="flex-shrink-0 p-2 bg-blue-100 rounded-lg">
          <TrendingUp size={20} className="text-blue-600" />
        </div>
        <div className="flex-1">
          <h3 className="mb-1 text-sm font-bold text-blue-900">What's Next?</h3>
          <p className="text-xs leading-relaxed text-blue-700">
            Your registration has been submitted successfully. You can track your
            registration status by clicking <span className="font-semibold">
              "View My Registrations"
            </span>. You'll receive email notifications with event updates and
            important information.
          </p>
        </div>
      </div>
    </motion.div>
  );
}

